import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx } from "vue";
import SubControllerTemplate from '@/templates/SubControllerTemplate.vue';
import SearchInput from '@/components/Form/SearchInput.vue';
import { i18n } from '@/locales';
import { getGlobalStore } from '@/lib/global-store';
import { computed, onBeforeUnmount, ref, watch, } from 'vue';
import { hubAdjustmentDailySearchOptionList as searchFieldOptionList } from '@/constants/hubAdjustment/daily';
import { reportTypeOptionMapper } from '@/types/entity/IHubAdjustmentDaily';
const path = 'views.hub_adjustment_daily.page_title.sales_detail';
export default /*@__PURE__*/ _defineComponent({
    __name: 'SubController',
    setup(__props) {
        const vuexStore = getGlobalStore();
        // 검색 유형
        const searchFieldType = ref('');
        const setSearchFieldType = (type) => {
            searchFieldType.value = type;
            // @ts-ignore
            vuexStore.dispatch('hubAdjustment/hubDailyReport/setSearchType', searchFieldType.value);
        };
        // 검색어
        const searchKeyword = ref('');
        const setSearchKeyword = (value) => {
            searchKeyword.value = value;
            // @ts-ignore
            vuexStore.dispatch('hubAdjustment/hubDailyReport/setKeyword', value);
        };
        // 현재 정산 타입
        const currentReportType = computed({
            get() { return vuexStore.state.hubAdjustment.hubDailyReport.reportType; },
            set() { },
        });
        const isSearchTypeSelectorExist = computed({
            get() {
                const type = currentReportType.value;
                const isExist = type === reportTypeOptionMapper.B2B_DELIVERY_CHARGE_DETAIL
                    || type === reportTypeOptionMapper.ROAD_SHOP_DELIVERY_CHARGE_DETAIL;
                return isExist;
            },
            set() { },
        });
        watch(() => isSearchTypeSelectorExist.value, (value) => {
            if (!value) {
                setSearchFieldType('');
                return;
            }
            setSearchFieldType(searchFieldOptionList[0].value);
        });
        // 현재 페이지 서브타이틀
        const title = computed({
            get() {
                return i18n.t(path, {
                    date: vuexStore.getters['hubAdjustment/hubDailyReport/getterSelectedDetailDate'],
                });
            },
            set() { },
        });
        /**
             * 검색유형 핸들러
             */
        const handleChangeSearchFieldType = (selectedType) => {
            setSearchFieldType(selectedType);
        };
        /**
             * 검색 핸들러
             */
        const handleSearch = (value) => {
            setSearchKeyword(value);
        };
        onBeforeUnmount(() => {
            setSearchFieldType('');
            setSearchKeyword('');
        });
        const locales = computed({
            get() {
                const searchInputPlaceholder = i18n.t('common.input_field_placeholder', {
                    field: i18n.t(isSearchTypeSelectorExist.value
                        ? 'common.search_word'
                        : 'common.store_name'),
                });
                return {
                    searchInputPlaceholder,
                };
            },
            set() { },
        });
        return (_ctx, _cache) => {
            const _component_v_select = _resolveComponent("v-select");
            return (_openBlock(), _createBlock(SubControllerTemplate, null, {
                titleSlot: _withCtx(() => [
                    _createTextVNode(_toDisplayString(title.value), 1 /* TEXT */)
                ]),
                area2: _withCtx(() => [
                    (isSearchTypeSelectorExist.value)
                        ? (_openBlock(), _createBlock(_component_v_select, {
                            key: 0,
                            "item-title": "text",
                            "item-value": "value",
                            flat: "",
                            density: "compact",
                            variant: "outlined",
                            class: "search-select",
                            "bg-color": "white",
                            dense: "",
                            solo: "",
                            "model-value": searchFieldType.value,
                            items: _unref(searchFieldOptionList),
                            "onUpdate:modelValue": handleChangeSearchFieldType
                        }, null, 8 /* PROPS */, ["model-value", "items"]))
                        : _createCommentVNode("v-if", true),
                    _createVNode(SearchInput, {
                        outlined: "",
                        class: "search-text-field",
                        placeholder: locales.value.searchInputPlaceholder,
                        "on-search": handleSearch,
                        "default-value": searchKeyword.value
                    }, null, 8 /* PROPS */, ["placeholder", "default-value"])
                ]),
                _: 1 /* STABLE */
            }));
        };
    }
});
